import { Component, Input, Output, EventEmitter } from '@angular/core';

export enum NetworkQuality {
  EXCELLENT = 'excellent',
  GOOD = 'good',
  FAIR = 'fair',
  POOR = 'poor',
  VERY_POOR = 'very-poor'
}

export enum QualityTrend {
  IMPROVING = 'improving',
  STABLE = 'stable',
  DEGRADING = 'degrading'
}

@Component({
  selector: 'app-network-quality-indicator',
  templateUrl: './network-quality-indicator.component.html',
  styleUrls: ['./network-quality-indicator.component.scss']
})
export class NetworkQualityIndicatorComponent {
  @Input() quality: NetworkQuality = NetworkQuality.GOOD;
  @Input() trend: QualityTrend = QualityTrend.STABLE;
  @Input() latency?: number;
  @Input() locationActive: boolean = false;
  @Output() locationClick = new EventEmitter<void>();

  NetworkQuality = NetworkQuality;
  QualityTrend = QualityTrend;

  get qualityLabel(): string {
    switch (this.quality) {
      case NetworkQuality.EXCELLENT:
        return 'Excellent';
      case NetworkQuality.GOOD:
        return 'Good';
      case NetworkQuality.FAIR:
        return 'Fair';
      case NetworkQuality.POOR:
        return 'Poor';
      case NetworkQuality.VERY_POOR:
        return 'Very Poor';
      default:
        return 'Unknown';
    }
  }

  get qualityColor(): string {
    switch (this.quality) {
      case NetworkQuality.EXCELLENT:
      case NetworkQuality.GOOD:
        return '#22c55e'; // Green
      case NetworkQuality.FAIR:
        return '#fbbf24'; // Yellow
      case NetworkQuality.POOR:
        return '#f59e0b'; // Orange
      case NetworkQuality.VERY_POOR:
        return '#ef4444'; // Red
      default:
        return '#6b7280'; // Gray
    }
  }

  get activeBars(): number {
    switch (this.quality) {
      case NetworkQuality.EXCELLENT:
        return 5;
      case NetworkQuality.GOOD:
        return 4;
      case NetworkQuality.FAIR:
        return 3;
      case NetworkQuality.POOR:
        return 2;
      case NetworkQuality.VERY_POOR:
        return 1;
      default:
        return 0;
    }
  }

  get bars(): boolean[] {
    return Array.from({ length: 5 }, (_, i) => i < this.activeBars);
  }

  get trendIcon(): string {
    switch (this.trend) {
      case QualityTrend.IMPROVING:
        return 'pi-arrow-up';
      case QualityTrend.DEGRADING:
        return 'pi-arrow-down';
      default:
        return '';
    }
  }

  get tooltipText(): string {
    let text = `Network: ${this.qualityLabel}`;
    if (this.latency !== undefined) {
      text += ` (${this.latency}ms)`;
    }
    if (this.trend === QualityTrend.IMPROVING) {
      text += ' - Improving';
    } else if (this.trend === QualityTrend.DEGRADING) {
      text += ' - Degrading';
    }
    return text;
  }

  get locationTooltip(): string {
    return this.locationActive
      ? 'Inspector location tracking active - Click to view map'
      : 'Location tracking inactive';
  }

  onLocationClick() {
    if (this.locationActive) {
      this.locationClick.emit();
    }
  }
}
